import { render, staticRenderFns } from "./tablecontentloader.vue?vue&type=template&id=0253d1c5"
import script from "./tablecontentloader.vue?vue&type=script&lang=js"
export * from "./tablecontentloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports